var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00D0A2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.435 2.826h-2.668V1.305c0-.307-.281-.544-.63-.544-.034 0-.057.01-.068.02a.1.1 0 0 0-.045-.02h-6.36c-.35 0-.62.237-.62.544v1.52H1.367C.6 2.826.003 3.35.003 4.022v1.955h1.182v11.132c0 .672.586 1.185 1.351 1.185h10.728c.766 0 1.362-.513 1.362-1.185V5.976h1.171V4.02c0-.67-.597-1.194-1.362-1.194m-9.152-.978h5.234v.978H5.283zm8.094 15.26c0 .07-.034.099-.113.099H2.536c-.078 0-.112-.03-.112-.1V5.978h10.953zm1.17-12.218H1.253v-.87c0-.068.034-.108.113-.108h13.069c.079 0 .112.04.112.109z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.169 7.25h1.249v8.988h-1.249zm-2.882 0h1.249v8.988H7.287zm-2.882 0h1.249v8.988H4.405z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.aa8113732aee42771189b6cad45ebf9e.svg";
export { ForwardRef as ReactComponent };